import { useState, useEffect } from "react";

function isStoreOpen(): boolean {
  const now = new Date();
  const eastern = new Date(
    now.toLocaleString("en-US", { timeZone: "America/Detroit" })
  );
  const hour = eastern.getHours();

  return hour >= 12 && hour < 18;
}

export function NeonOpenSign() {
  const [open, setOpen] = useState(isStoreOpen);

  useEffect(() => {
    const interval = setInterval(() => setOpen(isStoreOpen()), 60_000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      data-testid={`status-store-${open ? "open" : "closed"}`}
      className="relative inline-flex items-center"
    >
      <span
        className={`
          relative font-heading text-xl md:text-2xl uppercase tracking-[0.15em] font-bold select-none
          ${open ? "neon-open" : "neon-closed"}
        `}
      >
        {open ? "Open" : "Closed"}
      </span>
    </div>
  );
}
